export default __webpack_public_path__ + "static/media/macbook-back.a3befc92.png";